import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetSocialLinkByCountry } from "../../api-clients/configurationsClient";

function useGetSocialLinksByCountryQuery(countryCode?: string) {
  const query = useQuery({
    queryKey: [QUERY_KEYS.CONFIGURATIONS.SOCIAL_LINKS_BY_COUNTRY],
    queryFn: () => handleGetSocialLinkByCountry(countryCode || ""),
    enabled: !!countryCode,
  });

  return { socialLinks: query.data, query };
}

export default useGetSocialLinksByCountryQuery;
